import { z } from "zod";

export const signalSchema = z.object({
  confidence: z.number(),
  context: z
    .object({
      after: z
        .object({
          text: z.string(),
        })
        .optional(),
      before: z
        .object({
          text: z.string(),
        })
        .optional(),
    })
    .optional(),
  id: z.string(),
  quotee: z
    .object({
      full_name: z.string(),
      id: z.string(),
    })
    .optional(),
  signal_type: z.string().array(),
  text: z.string(),
  time: z.number(),
});
